import axios from 'axios';
import { V1API } from '../../../_helpers/APIPath';
import { encode, decode } from '../../dataMagic';
import { populateStore, performNetworkCall, buildFormData } from '@/store/asyncHelper';



const mutations = {};
const store = {};

populateStore(store, mutations, false);

export default {
    namespaced: true,

    state : {

        submission:[],
        submission_detail:{},
        attachment:[],

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        attachmentSubmitLoading: false,
        attachmentSubmitError: false,
        attachmentSubmitSuccess: false,

        submissionLoading: false,
        submissionError: false,



        ...store
    },

    mutations : {
        ...mutations,

        SET_SUBMISSION(state, fellow) {
            state.submission = fellow;
        },
        SET_SUBMISSION_DETAIL(state, detail) {
            state.submission_detail = detail;
            console.log('statw', state.submission_detail.data);
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },
        SET_ATTACH(state, detail) {
            state.attachment = detail;
        },
        ATTACH_LOADING (state, loading) {
            state.attachmentSubmitLoading = loading;
        },
        ATTACH_SUCCESS (state, success) {
            state.attachmentSubmitSuccess = success;
        },

        ATTACH_ERROR (state, hasError) {
            state.attachmentSubmitError = hasError;
        },


        SUBMISSION_LOADING (state, loading) {
            state.submissionLoading = loading;
        },

        SUBMISSION_ERROR (state, hasError) {
            state.submissionError = hasError;
        },




    },

    actions: {

        async createSubmission ({ commit, dispatch }, payload) {
            commit('SUBMISSION_LOADING', true);
            commit('SUBMISSION_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                },
            };

            try{
                let response = await axios.post(V1API.submission_create_participant, payload, config).then(result=>{
                    let data = result.data;
                    return data;

                });

                commit('SUBMIT_SUCCESS', true);


                return response;

            }catch (e) {
                commit('SUBMISSION_ERROR', true);
            }finally {
                commit('SUBMISSION_LOADING', false);
            }
        },
        async adminCreateSubmission ({ commit, dispatch }, payload) {
            commit('SUBMISSION_LOADING', true);
            commit('SUBMISSION_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                },
            };

            try{
                let response = await axios.post(V1API.submission_create_admin, payload, config).then(result=>{
                    let data = result.data;
                    return data;

                });

                commit('SUBMIT_SUCCESS', true);


                return response;

            }catch (e) {
                commit('SUBMISSION_ERROR', true);
            }finally {
                commit('SUBMISSION_LOADING', false);
            }
        },
        async adminCreateScreening ({ commit, dispatch }, payload) {
            commit('SUBMISSION_LOADING', true);
            commit('SUBMISSION_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                },
            };

            try{
                let response = await axios.post(V1API.submission_screening_add, payload, config).then(result=>{
                    let data = result.data;
                    return data;

                });

                commit('SUBMIT_SUCCESS', true);

                dispatch('fetchSubmissionDetail',payload.submission)
                return response;

            }catch (e) {
                commit('SUBMISSION_ERROR', true);
            }finally {
                commit('SUBMISSION_LOADING', false);
            }
        },
        async ReviewerCreateRemark ({ commit, dispatch }, payload) {
            commit('SUBMISSION_LOADING', true);
            commit('SUBMISSION_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                },

            };
            console.log(payload);

            try{
                let response = await axios.post(V1API.submission_remark_add, payload, config).then(result=>{
                    let data = result.data;
                    return data;

                });

                commit('SUBMIT_SUCCESS', true);

                dispatch('fetchReviewerSubmissionDetail',payload.submission)
                console.log(response);
                return response;

            }catch (e) {
                commit('SUBMISSION_ERROR', true);
            }finally {
                commit('SUBMISSION_LOADING', false);
            }
        },

        async fetchMySubmissionDetail ({ commit }) {
            commit('SUBMISSION_LOADING', true);
            commit('SUBMISSION_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.submission_own_participant, config);
                let response = result.data;

                commit('SET_SUBMISSION_DETAIL', response);
                return response

            } catch(error) {
                commit('SUBMISSION_ERROR', true);
            } finally {
                commit('SUBMISSION_LOADING', false);
            }
        },

        async fetchSubmissionDetail ({ commit },payload) {
            commit('SUBMISSION_LOADING', true);
            commit('SUBMISSION_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.submission_detail+payload, config);
                let response = result.data;
                console.log(response.data);

                commit('SET_SUBMISSION_DETAIL', response);
                return response

            } catch(error) {
                commit('SUBMISSION_ERROR', true);
            } finally {
                commit('SUBMISSION_LOADING', false);
            }
        },

        async fetchReviewerSubmissionDetail ({ commit },payload) {
            commit('SUBMISSION_LOADING', true);
            commit('SUBMISSION_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.submission_reviewer_detail+payload, config);
                let response = result.data;
                console.log(response.data);

                commit('SET_SUBMISSION_DETAIL', response);
                return response

            } catch(error) {
                commit('SUBMISSION_ERROR', true);
            } finally {
                commit('SUBMISSION_LOADING', false);
            }
        },




        async fetchSubmissionList ({ commit }) {
            commit('SUBMISSION_LOADING', true);
            commit('SUBMISSION_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.submission_list, config);
                let response = result.data;

                commit('SET_SUBMISSION', response.data);

            } catch(error) {
                commit('SUBMISSION_ERROR', true);
            } finally {
                commit('SUBMISSION_LOADING', false);
            }
        },

        async fetchSubmissionListByStage({ commit },payload) {
            commit('SUBMISSION_LOADING', true);
            commit('SUBMISSION_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.submission_list_by_stage+payload, config);
                let response = result.data;

                commit('SET_SUBMISSION', response.data);

            } catch(error) {
                commit('SUBMISSION_ERROR', true);
            } finally {
                commit('SUBMISSION_LOADING', false);
            }
        },



        async updateSubmission ({ commit, dispatch }, payload) {
            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try {

                let response = await axios.patch(V1API.submission_update_own_participant, payload, config).then(result=>{
                    let data = result.data;
                    return data;

                });
                dispatch('fetchMySubmissionDetail');

                commit('SUBMIT_SUCCESS', true);

                return response;

            }catch (e) {
                commit('SUBMISSION_ERROR', true);
            }finally {
                commit('SUBMISSION_LOADING', false);
            }
        },
        async AdminUpdateSubmission ({ commit, dispatch }, payload) {
            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try {

                let response = await axios.patch(V1API.submission_update_admin, payload, config).then(result=>{
                    let data = result.data;
                    return data;

                });
                dispatch('fetchSubmissionDetail',response.data.id);

                commit('SUBMIT_SUCCESS', true);

                return response;

            }catch (e) {
                commit('SUBMISSION_ERROR', true);
            }finally {
                commit('SUBMISSION_LOADING', false);
            }
        },

        async fetchAttachmentList ({ commit },payload ) {
            commit('SUBMISSION_LOADING', true);
            commit('SUBMISSION_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.submission_attachment_list+'/'+payload, config);
                let response = result.data;

                commit('SET_ATTACH', response.data);

            } catch(error) {
                commit('SUBMISSION_ERROR', true);
            } finally {
                commit('SUBMISSION_LOADING', false);
            }
        },
         async fetchScreeningList ({ commit },payload ) {
                    commit('SUBMISSION_LOADING', true);
                    commit('SUBMISSION_ERROR', false);

                    let config = {
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        }
                    };

                    try{
                        let result = await axios.get(V1API.submission_attachment_list+'/'+payload, config);
                        let response = result.data;

                        commit('SET_ATTACH', response.data);

                    } catch(error) {
                        commit('SUBMISSION_ERROR', true);
                    } finally {
                        commit('SUBMISSION_LOADING', false);
                    }
                },

        async addAttachment ({commit, dispatch}, payload) {
            commit('ATTACH_LOADING', true);
            commit('ATTACH_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                "Content-Type": "multipart/form-data"
            };
            try{
                console.log(payload, "payload")
                let data= new FormData()
                let payloadData = buildFormData(data, payload);

                let response = await axios.post(V1API.submission_attachment_upload, payloadData, config).then(result=>{

                    let data = result.data
                    return data

                });

                commit('ATTACH_SUCCESS', true);
                dispatch("fetchAttachmentList",payload.submission)
                return response

            }catch (e) {
                console.log(e)

                commit('ATTACH_ERROR', true);
            }finally {

                commit('ATTACH_LOADING', false);
            }
        },

        async deleteAttachment ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.submission_attachment_delete + payload.id+"/delete", config).then(result=>{
                let data = result.data
                return data
            })

            dispatch ('fetchAttachmentList',payload.submission)

            return response
        },
        async updateStatusToggle({ commit, dispatch }, payload) {
            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };
            console.log(payload.delete);
            let response = await axios.patch(V1API.submission_status_toggle+payload.submission, payload.details, config).then(result=>{
                let data = result.data;
                return data;
            });

            dispatch ('fetchSubmissionDetail', payload.submission);

            return response;
        },
        async updateStageToggle({ commit, dispatch }, payload) {
            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };
            console.log(payload.delete);
            let response = await axios.patch(V1API.submission_stage_toggle+payload.submission, payload.details, config).then(result=>{
                let data = result.data;
                return data;
            });

            dispatch ('fetchSubmissionDetail', payload.submission);

            return response;
        },























    },

    getters: {}
};
